import { useEffect } from 'react';

export const SAVE_SUCCESS_DELAY = 2000;

function useTimeout (callback, timeout = 0) {
  useEffect(() => {
    const timeoutId = setTimeout(callback, timeout);
    return () => clearTimeout(timeoutId, callback, timeout);
  }, [callback, timeout]);
}

export default useTimeout;
